import React from 'react';
import '../Estilos/DateInput.css';
import '../Estilos/Fontes.css';

export default function DateInput(props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginLeft: props.marginLeft ? props.marginLeft : null,
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: props.largura ? props.largura : '100%',
        padding: 0,
        margin: 0,
        marginTop: props.top ? props.top : 0,
      }}
    >
      <h1
        style={{
          fontSize: '14px',
          color: '#005288',
          fontWeight: 500,
          fontFamily: 'montserrat',
          paddingLeft: 8,
          textAlign: 'left',
          width: '100%',
        }}
      >
        {props.titulo}
      </h1>

      <div style={{ display: 'flex', width: '100%', borderRadius: 5 }}>
        <input
          type="date"
          id="data"
          defaultValue={props.padrao ? new Date(props.padrao).toISOString().split('T')[0] : ''}
          onChange={(data) => {
            props.clicado(data.target.value);
          }}
          disabled={props.disabled}
        />
      </div>
      {props.erro && (
        <div
          style={{
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingTop: 8,
          }}
        >
          <img src={require('../Icones/block.svg').default} alt="block" />
          <h4
            style={{
              color: 'red',
              fontSize: 12,
              padding: 0,
              margin: 0,
              verticalAlign: 'center',
              paddingLeft: 8,
              fontFamily: 'montserrat',
              fontWeight: 500,
            }}
          >
            {props.erroTexto}
          </h4>
        </div>
      )}
    </div>
  );
}
